import { render, staticRenderFns } from "./StatRow.vue?vue&type=template&id=ee371434&scoped=true"
import script from "./StatRow.vue?vue&type=script&lang=js"
export * from "./StatRow.vue?vue&type=script&lang=js"
import style0 from "./StatRow.vue?vue&type=style&index=0&id=ee371434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee371434",
  null
  
)

export default component.exports